// Extra-usage + auto-reload calls to presage-usage. Response shapes are the
// "API contract" table in section 2 (presage-usage) of the plan
// 2026-10-13-premium-prepay-extra-usage.md: real HTTP status codes, error
// bodies {"error": "<message>"}, and no legacy {response:{resultMessage}}
// envelope.
import { fetchAuthSession } from "aws-amplify/auth";

export class BillingApiError extends Error {
  constructor(status, message) {
    super(message);
    this.name = "BillingApiError";
    this.status = status;
  }
}

async function authHeaders() {
  const session = await fetchAuthSession();
  const jwt = session?.tokens?.accessToken;
  if (!jwt) throw new BillingApiError(401, "Not signed in");
  return { "Content-Type": "application/json", Authorization: `Bearer ${jwt}` };
}

function endpoint(envName) {
  return `${process.env.REACT_APP_USAGE_API}${process.env[envName]}`;
}

async function readJson(res) {
  try {
    return await res.json();
  } catch {
    return null;
  }
}

// GET and PUT users/auto-reload answer 200 with the flat settings state
// {enabled, monthly_cap_cents, disabled_reason, extra_credits,
// auto_reload_spend_cents, pending}. Callers get it nested the way the user
// row stores it: auto_reload {enabled, monthly_cap_cents, disabled_reason}.
async function readAutoReload(res) {
  const body = await readJson(res);
  if (!res.ok) {
    const text = typeof body?.error === "string" ? body.error : `Request failed (${res.status})`;
    throw new BillingApiError(res.status, text);
  }
  if (typeof body?.enabled !== "boolean") {
    throw new BillingApiError(res.status, "Unexpected auto-reload response");
  }
  return {
    auto_reload: {
      enabled: body.enabled,
      monthly_cap_cents: body.monthly_cap_cents,
      disabled_reason: body.disabled_reason,
    },
    auto_reload_spend_cents: body.auto_reload_spend_cents,
    auto_reload_pending: body.pending,
    extra_credits: body.extra_credits,
  };
}

export async function getAutoReload() {
  const headers = await authHeaders();
  const res = await fetch(endpoint("REACT_APP_AUTO_RELOAD_ENDPOINT"), { headers });
  return readAutoReload(res);
}

export async function putAutoReload({ enabled, monthly_cap_cents }) {
  const headers = await authHeaders();
  const res = await fetch(endpoint("REACT_APP_AUTO_RELOAD_ENDPOINT"), {
    method: "PUT",
    headers,
    body: JSON.stringify({ enabled, monthly_cap_cents }),
  });
  return readAutoReload(res);
}

export async function createExtraUsageCheckout() {
  const headers = await authHeaders();
  const res = await fetch(endpoint("REACT_APP_STRIPE_CREATE_EXTRA_USAGE_CHECKOUT"), {
    method: "POST",
    headers,
    body: JSON.stringify({}),
  });
  const body = await readJson(res);
  if (!res.ok || !body?.sessionId) {
    throw new BillingApiError(res.status, "Could not start checkout");
  }
  return body.sessionId;
}
